import { z } from 'zod';
import { dataAccessEnvironment } from '../models/data-access-environment';

/**
 * This function will return a successfully parsed object based on a zod schema or return an empty object and log a zod error to the console.
 * @param requestSchema zod schema
 * @param value value to parse
 * @returns Stringified JSON object of parsed schema
 */
export function parseRequestSchema<T extends z.ZodTypeAny>(
  requestSchema: T,
  value: unknown
) {
  let parsedData: z.infer<typeof requestSchema> = {};
  try {
    parsedData = requestSchema.parse(value);
  } catch (zodError) {
    if (dataAccessEnvironment.configuration.showZodErrorsInConsole) {
      console.error(zodError);
    }
  }
  return JSON.stringify(parsedData);
}
